// for performance and prediction summaries

export enum CalibrateMode {
  Unavailable = 'Unavailable',
  ContactSupport = 'ContactSupport',
  Calibrate = 'Calibrate',
}

// what stage of remote vision calibration are we in
// differs from VisionRemoteStep which refers to commands sent to the machine
export enum VisionRemoteStage {
  Overview = 'Overview',
  PlateDistance = 'PlateDistance',
  LeaderCalibration = 'LeaderCalibration',
  FollowerCalibration = 'FollowerCalibration',
  Verification = 'Verification',
}

export const VISION_REMOTE_STAGES: Record<
  VisionRemoteStage,
  {
    index: number;
    title: string;
    value: VisionRemoteStage;
    description: string;
  }
> = {
  [VisionRemoteStage.Overview]: {
    index: 0,
    title: 'Overview',
    value: VisionRemoteStage.Overview,
    description: '',
  },
  [VisionRemoteStage.PlateDistance]: {
    index: 1,
    title: 'Plate Distance Verification',
    value: VisionRemoteStage.PlateDistance,
    description:
      "Make sure the distance between the machine and the plate hasn't changed. If it didn't, enter the previous measured distance; if it did, please ask an operator to measure from the back of home plate to the front of the HDPE Panels.",
  },
  [VisionRemoteStage.LeaderCalibration]: {
    index: 2,
    title: 'Leader Camera Calibration (3rd Base Side)',
    value: VisionRemoteStage.LeaderCalibration,
    description:
      'Adjust the leader camera orientation and position for optimal plate coverage',
  },
  [VisionRemoteStage.FollowerCalibration]: {
    index: 3,
    title: 'Follower Camera Calibration (1st Base Side)',
    value: VisionRemoteStage.FollowerCalibration,
    description:
      'Adjust the follower camera orientation and position for optimal plate coverage',
  },
  [VisionRemoteStage.Verification]: {
    index: 4,
    title: 'Calibration Verification',
    value: VisionRemoteStage.Verification,
    description:
      'Review the calibration results and verify distance calculations.',
  },
};
